<!--面试邀请，修改面试邀请功能删除了-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="面试邀请"
    append-to-body
    width="600px"
    class="dialog"
    @close="toClose"
  >
    <h4 class="middle">您有一份面试邀请待查看！</h4>
    <h4>亲爱的{{ name }}：</h4>
    <div class="description">
      <span
      >您好！我司人力资源部已初审您的简历，经过初步筛选，认为您基本具备本公司招聘的岗位的要求，因此，正式通知您来我公司参加面试。</span
      >
    </div>
    <el-form
      ref="form"
      :model="dialogForm"
      :rules="dialogRules"
      class="form"
      label-position="right"
      label-width="100px"
    >
      <el-form-item prop="positionId" label="面试职位：">
        <el-select
          v-model="dialogForm.positionId"
          placeholder="请选择面试职位：可搜索"
        >
          <el-option
            v-for="item in positionList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.enterpriseName
            }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="interviewTime" label="面试时间：">
        <div class="date">
          <el-date-picker
            v-model="dialogForm.interviewTime"
            :picker-options="expireTimeOptions"
            type="datetime"
            placeholder="请选择面试时间"
            class="input"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </div>
      </el-form-item>
      <el-form-item prop="address" label="面试地址：">
        <el-input
          v-model="dialogForm.address"
          placeholder
          class="input"
        />
      </el-form-item>
      <el-form-item prop="contactPerson" label="联系人：">
        <el-input
          v-model="dialogForm.contactPerson"
          placeholder
          class="input"
        />
      </el-form-item>
      <el-form-item prop="contactPhone" label="联系电话：">
        <el-input
          v-model="dialogForm.contactPhone"
          placeholder
          class="input"
        />
      </el-form-item>
      <el-form-item prop="precautions" label="注意事项：" class="precautions">
        <el-checkbox-group v-model="dialogForm.precautions">
          <el-checkbox label="请带简历"/>
          <el-checkbox label="请带毕业证书"/>
          <el-checkbox label="请带作品"/>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item prop="busRoute" label="乘车路线：">
        <el-input
          v-model="dialogForm.busRoute"
          placeholder
          class="input"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        :loading="isLoading"
        type="primary"
        @click="toSure"
      >
        确定
      </el-button>
    </div>
  </el-dialog>
</template>
<script type="text/ecmascript-6">
import { validatePhones } from '@/assets/js/enterprise/index'
import { mapState } from 'vuex'
export default {
  props: {
    // 简历名字
    name: {
      type: String,
      default() {
        return ''
      }
    },
    positionType: {
      type: Number,
      default() {
        return 0
      }
    },
    // 面试邀请需要的id
    id: {
      type: String,
      default() {
        return ''
      }
    },
    interviewDialogShow: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      isLoading: false,
      dialogVisible: false,
      positionList: [],
      // 置灰过期的时间
      expireTimeOptions: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      dialogForm: {
        precautions: [],
        positionId: '',
        interviewTime: null,
        address: null,
        contactPerson: null,
        contactPhone: null,
        busRoute: null
      },
      dialogRules: {
        positionId: {
          required: true,
          message: '请选择面试职位',
          trigger: 'change'
        },
        interviewTime: {
          required: true,
          message: '请选择时间',
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请输入面试地址',
          trigger: 'blur'
        },
        contactPerson: {
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        },

        contactPhone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { validator: validatePhones, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.base.userInfo
    })
  },
  watch: {
    interviewDialogShow(v) {
      this.dialogVisible = v
      if (v) {
        this.getPositionList()
      }
      !v &&
        setTimeout(() => {
          this.$refs.form.resetFields()
        })
    }
  },

  methods: {
    getPositionList() {
      if (this.userInfo) {
        this.dialogForm['address'] = this.userInfo.address
        this.dialogForm['contactPhone'] = this.userInfo.phone
      }
      this.$api.getAllPositionRelase(
        {
          type: this.positionType,
          enterpriseId: this.$route.query.enterpriseId
        },
        (res) => {
          this.positionList = res
        }
      )
    },
    toClose() {
      this.dialogVisible = false
      this.$emit('close')
    },
    toSure() {
      // 2新增面试邀请
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.dialogForm.precautions = this.dialogForm.precautions.join(',')
          this.$api.interview(
            this.id,
            this.dialogForm,
            () => {
              this.$message.success('面试邀请发送成功！')
              this.$emit('close', 1)
              this.dialogVisible = false
            },
            () => {
              this.isLoading = false
            }
          )
        }
      })
    }
  }

}
</script>

<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/enterprise_color.scss";
@import "@/assets/css/buttons.scss";
@import "@/assets/css/interview.scss";
</style>



// WEBPACK FOOTER //
// src/model/interviewDialog.vue